/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Control_DescInputs */

const en_mk_nav_control_desc = /** @type {(inputs: Mk_Nav_Control_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track costs, changes, and readiness.`)
};

const id_mk_nav_control_desc = /** @type {(inputs: Mk_Nav_Control_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantau biaya, perubahan, dan kesiapan.`)
};

/**
* | output |
* | --- |
* | "Track costs, changes, and readiness." |
*
* @param {Mk_Nav_Control_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_control_desc = /** @type {((inputs?: Mk_Nav_Control_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Control_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_control_desc(inputs)
	return en_mk_nav_control_desc(inputs)
});